import { render, staticRenderFns } from "./SigningPersonRuleQuantativeForm.vue?vue&type=template&id=2700ff84&"
import script from "./SigningPersonRuleQuantativeForm.vue?vue&type=script&lang=js&"
export * from "./SigningPersonRuleQuantativeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports